import { render, staticRenderFns } from "./logisticsOrder.vue?vue&type=template&id=5421c779&scoped=true&"
import script from "./logisticsOrder.vue?vue&type=script&lang=js&"
export * from "./logisticsOrder.vue?vue&type=script&lang=js&"
import style0 from "./logisticsOrder.vue?vue&type=style&index=0&id=5421c779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421c779",
  null
  
)

export default component.exports